import axios from '@/libs/api.request'

export const fetchServers = () => {
  return axios.request({
    url: '/v1/api/servers',
    method: 'get'
  })
}

export const fetchServer = () => {
  return axios.request({
    url: '/v1/api/server/'  + id,
    method: 'get'
  })
}

export const editServers = (data) => {
  return axios.request({
    url: '/v1/api/servers/' + data._id,
    data,
    method: 'put'
  })
}

export const addServer = (data) => {
  return axios.request({
    url: '/v1/api/servers',
    data,
    method: 'post'
  })
}

export const delServer = (id) => {
  return axios.request({
    url: '/v1/api/servers/' + id,
    method: 'delete'
  })
}
